import ContactsRequests from '../../server/contacts';


export const setContactsSearched = searched => ({
  type: 'GET_USERS_CONTACTS_SEARCHED',
  searched,
});

export const searchSphereContacts = search => async (dispatch) => {
  const searched = await ContactsRequests.searchSphereContacts(search);
  dispatch(setContactsSearched(searched));
};

export default {
  searchSphereContacts,
};
